import { prop } from 'ramda';
import { xmlStringToBoolean } from '../../utility/xmlHelpers';
import {
    addSelectionItemToCustomPicker,
    closeDropdown,
    handleKeyboardNavigation,
    SELECTOR_PEOPLE_PICKER_DROPDOWN_ITEM,
    SELECTOR_SELECTION_ITEM,
    updateFocusedItem,
} from '../helpers/peoplePicker.helpers';

const $ = window.jQuery;

const maxResultCount = 100;

// DOMNode -> PersonSearchEventValues
export const getSearchValues = (searchBoxNode) => {
    const $item = $(searchBoxNode);
    const $container = $item.closest('.custom-picker-input-container');
    const $pplPicker = $container.closest('.custom-people-picker');
    const $dropdown = $pplPicker.find('.custom-picker-dropdown').first();
    const $selectNode = $pplPicker.find('.ppl-picker').first();
    const searchPeopleOnly = xmlStringToBoolean(
        $selectNode.attr('searchPeopleOnly'),
    );

    return {
        searchText: $item.val(),
        maxCount: maxResultCount,
        $selectNode,
        $dropdown,
        searchPeopleOnly,
    };
};

const setupNewPeoplePickerUi = (function () {
    return function (node, isMulti, data) {
        const $peoplePickerNode = $(node);
        const selectedItems = data || [];
        const selectedIds = selectedItems.map(prop('AccountId'));
        $peoplePickerNode.val(selectedIds);
        $peoplePickerNode.data('selectedPpl', selectedItems);

        const $container = $peoplePickerNode.closest('.custom-people-picker');
        if (!$container.length) {
            console.error(
                'Cannot find custom-people-picker container for',
                $peoplePickerNode,
            );
            return;
        }

        const $inputContainer = $container.find(
            '.custom-picker-input-container',
        );
        const $input = $inputContainer.find('.custom-picker-input');
        const $dropdown = $container.find('.custom-picker-dropdown');
        const $select = $container.find('select');

        $select.hide();
        $inputContainer.show();

        $container.find(SELECTOR_SELECTION_ITEM).remove();
        for (const item of selectedItems) {
            addSelectionItemToCustomPicker($container, item, $peoplePickerNode);
        }

        if (!isMulti && selectedItems.length > 0) {
            $input.attr('placeholder', '');
        }

        // Check if this node has been initialized before
        if (!$peoplePickerNode.data('isInitialized')) {
            $input.on('blur', function () {
                setTimeout(() => {
                    closeDropdown($dropdown);
                }, 200);
            });

            $input.on('keydown', (e) => handleKeyboardNavigation(e, $dropdown));

            $inputContainer.on('click', function (e) {
                $input.focus();
                e.stopPropagation();
            });

            $dropdown.on(
                'mouseenter',
                SELECTOR_PEOPLE_PICKER_DROPDOWN_ITEM,
                function (e) {
                    updateFocusedItem($(e.target).index(), $dropdown);
                },
            );

            $peoplePickerNode.data('isInitialized', true);
        }
    };
})();

export default setupNewPeoplePickerUi;
